import React, { CSSProperties } from 'react'
import { Arrow, Oval, Star, Triangle } from './SVG'
import { TitleCss, TitleSpecialCss } from './index.css'

interface IProps {
	title: string | React.ReactNode
	marker: 'triangle' | 'star'
	colorMarker?: string
	backgound?: 'arrow' | 'oval'
	backgroundColor?: string
	titleStyle?: CSSProperties
}

export default function Title({
	title,
	marker,
	backgound,
	titleStyle,
	colorMarker,
	backgroundColor
}: IProps) {
	return (
		<TitleCss style={titleStyle}>
			{marker === 'triangle' ? (
				<Triangle className='marker' color={colorMarker} />
			) : (
				<Star className='marker' />
			)}
			{!backgound ? null : backgound === 'oval' ? (
				<Oval className='bg__oval' color={backgroundColor} />
			) : (
				<Arrow className='bg__arrow' />
			)}
			<h2 dangerouslySetInnerHTML={{ __html: `${title}` }} />
		</TitleCss>
	)
}

export function TitleSpecial({
	title,
	marker,
	backgound,
	titleStyle,
	backgroundColor
}: IProps) {
	return (
		<TitleSpecialCss style={titleStyle}>
			<span>
				{marker === 'triangle' ? (
					<Triangle className='marker' />
				) : (
					<Star className='marker' />
				)}
				<span>
					{' '}
					{!backgound ? null : backgound === 'oval' ? (
						<Oval className='bg__oval' color={backgroundColor} />
					) : (
						<Arrow className='bg__arrow' />
					)}
				</span>
			</span>
			<span dangerouslySetInnerHTML={{ __html: `${title ?? ''}` }} />
		</TitleSpecialCss>
	)
}
